<template>
  <email-box>
    <button-link
      v-if="isMobile"
      class="mb-100"
      @click="goBackToList"
    >Back To List</button-link>

    <form-field-select-leads
      v-if="availableRecords"
      v-model="form.record_id"
      :records="availableRecords"
      :validation-errors="validationErrors.record_id"
    >
    </form-field-select-leads>

    <form-field-select-user-emails
      v-model="form.user_id"
      :validation-errors="validationErrors.user_id"
    ></form-field-select-user-emails>

    <div class="flex flex-between flex-vertical-end">
      <form-field-collection
        class="flex-grow"
        label="To"
        v-model="form.to"
        placeholder="add email addresses"
        allow-new
        :validation-errors="validationErrors.to"
      ></form-field-collection>

      <button-link
        class="cc_bcc_button"
        @click="showCcBcc = !showCcBcc"
      >{{ showCcBcc ? 'HIDE' : 'SHOW' }} CC/BCC</button-link>
    </div>

    <grid-row v-if="showCcBcc">
      <grid-column>
        <form-field-collection
          label="CC"
          v-model="form.cc"
          placeholder="add email addresses"
          allow-new
          :validation-errors="validationErrors.cc"
        ></form-field-collection>
      </grid-column>

      <grid-column>
        <form-field-collection
          label="BCC"
          v-model="form.bcc"
          placeholder="add email addresses"
          allow-new
          :validation-errors="validationErrors.bcc"
        ></form-field-collection>
      </grid-column>
    </grid-row>

    <form-field-editor
      ref="subjectField"
      label="Subject"
      v-model="form.subject"
      type="shortCodesOnly"
      is-single-line
      short-code-type="record"
      :validation-errors="validationErrors.subject"
    ></form-field-editor>

    <form-field-attachment
      v-if="$store.getters.mailgunIsIntegrated"
      v-model="form.attachments"
      :validation-errors="attachmentErrors"

    ></form-field-attachment>

    <form-field-editor
      ref="bodyField"
      label="Message"
      placeholder="write your text here..."
      v-model="form.body"
      type="email"
      short-code-type="record"
      is-tall
      :validation-errors="validationErrors.body"
      @email-snippet-selected="handleEmailSnippet"
    ></form-field-editor>

    <template v-slot:footer>
      <div class="flex flex-between">
        <form-field-select
          class="mb-0"
          v-model="sendNow"
        >
          <option :value="true">Send Now</option>
          <option :value="false">Send Later</option>
        </form-field-select>

        <form-field-datetime-picker
          class="mb-0 ml-50"
          v-if="!sendNow"
          v-model="form.datetime"
          :min-date="minDate"
          position="is-top-right"
        ></form-field-datetime-picker>
      </div>

      <button-default
        v-if="sendNow"
        :loading="isLoading"
        :disabled="isLoading"
        @click="sendEmailNow"
      >Send Email</button-default>

      <button-default
        v-if="!sendNow"
        :loading="isLoading"
        :disabled="isLoading"
        @click="sendEmailLater"
      >Schedule Email</button-default>
    </template>
  </email-box>
</template>

<script>
import EmailBox from "./EmailBox"
import dates from "../../../services/dates";

export default {
  name: "NewEmail",
  components: {EmailBox},
  props: {
    contact: {
      type: Object,
      required: true
    },
    record: {
      type: Object,
      required: false
    },
    defaultData: Object,
    availableRecords: {
      type: Array,
    }
  },
  data() {
    return {
      isLoading: false,
      showCcBcc: false,
      minDate: dates.getNowJSDate(),
      sendNow: true,
      form: {},
      defaultForm: {
        id: this.contact.id,
        record_id: null,
        user_id: this.$store.getters.authUser.id,
        to: [this.contact.email_address],
        cc: [],
        bcc: [],
        subject: '',
        body: '',
        attachments: [],
        datetime: dates.getTomorrowJSDate(9, 17),
      },
      validationErrors: {},
    }
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
    attachmentErrors() {
      let errors = [];

      Object.keys(this.validationErrors).forEach((errorKey) => {
        if (errorKey.match('attachments') ) {
          errors.push(this.validationErrors[errorKey][0])
        }
      })

      return errors;
    },
  },
  created() {
    this.form = this.$utils.clone(this.defaultForm);
    this.setupRecordId();

    if(this.defaultData && this.defaultData.user_id) {
      this.form.user_id = this.defaultData.user_id;
    }

    if(this.defaultData && this.defaultData.to) {
      this.form.to = this.defaultData.to;
    }

    if(this.defaultData && this.defaultData.cc) {
      this.form.cc = this.defaultData.cc;
    }

    if(this.defaultData && this.defaultData.bcc) {
      this.form.bcc = this.defaultData.bcc;
    }

    if(this.defaultData && this.defaultData.subject) {
      this.form.subject = this.defaultData.subject;
    }

    if(this.defaultData && this.defaultData.body) {
      const data = this.defaultData;

      this.form.body = `<br>`;
      this.form.body += `<p style="font-size: 12px">On ${data.date} ${data.name} (${data.from}) wrote: </p>`;
      this.form.body += this.defaultData.body;
    }
  },
  methods: {
    handleEmailSnippet(snippet) {
      this.form.subject = snippet.subject
    },
    goBackToList() {
      this.$emit('back')
    },
    setupRecordId() {
      // used on Inbox page
      if (this.record && !this.availableRecords) {
        this.form.record_id = this.record.id
      }

      if (this.defaultData && this.defaultData.record_id) {
        this.form.record_id = this.defaultData.record_id;
      }
    },
    clearPayload () {
      this.form = this.$utils.clone(this.defaultForm);
      this.setupRecordId();
      this.$refs.subjectField.clear();
      this.$refs.bodyField.clear();
      this.validationErrors = {};
    },
    sendEmailNow() {
      this.isLoading = true;

      this.$api.communicationLogs.emailContact(this.form, this.validationErrors)
        .then(response => {
          this.$buefy.toast.open({message: 'Successfully Sent Email', type: 'is-success'});
          this.clearPayload()
        })
        .catch((error) => {
          if (error.response.status === 422) this.validationErrors = error.response.data.errors;
          if (error.response.status === 413) this.validationErrors = {attachments: ['File Size too large, try to compress it']};
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    sendEmailLater() {
      this.isLoading = true;

      this.$api.communicationLogs.scheduledEmailContact(this.form, this.validationErrors)
        .then(() => {
          this.$buefy.toast.open({message: 'Successfully Scheduled Email', type: 'is-success'});
          this.clearPayload()
        })
        .catch((error) => {
          if (error.response.status === 422) this.validationErrors = error.response.data.errors;
          if (error.response.status === 413) this.validationErrors = {attachments: ['File Size too large, try to compress it']};
        })
        .finally(() => {
          this.isLoading = false
        });
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.cc_bcc_button {
  height: 2.5em;
  margin-bottom: 0.75rem;
  margin-left: 2rem;
}

</style>
